import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COOKIE_CONSENT_KEY } from "@/lib/legal";
import { applyAdsPersonalization } from "@/components/AdSenseLoader";
import { useBodyClass } from "@/lib/useBodyClass";

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  useBodyClass("cookie-banner-open", visible);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_CONSENT_KEY)) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  const choose = (value) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ value, date: new Date().toISOString() }));
    applyAdsPersonalization(value);
    setVisible(false);
    toast.success(value === "all" ? "Preferencias de cookies guardadas" : "Solo cookies necesarias; los anuncios no serán personalizados");
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Aviso de cookies"
      data-testid="cookie-consent-banner"
      className="fixed inset-x-3 sm:inset-x-auto sm:left-6 sm:max-w-md z-50 bg-white border border-slate-200 shadow-2xl shadow-slate-900/10 rounded-2xl p-4 sm:p-5 slide-up above-mobile-bar"
    >
      <div className="flex items-start gap-3">
        <span className="hidden sm:flex h-10 w-10 rounded-xl bg-cyan-50 text-cyan-600 items-center justify-center shrink-0">
          <Cookie className="h-5 w-5" />
        </span>
        <div>
          <p className="font-heading font-semibold text-slate-900 flex items-center gap-2">
            <Cookie className="h-4 w-4 text-cyan-600 sm:hidden" /> Usamos cookies
          </p>
          <p className="text-sm text-slate-600 mt-1 leading-relaxed">
            <span className="hidden sm:inline">Empleamos cookies técnicas imprescindibles (sesión y pago seguro), de preferencias para recordar tu
            idioma y cookies publicitarias de Google AdSense. </span>
            <span className="sm:hidden">Cookies técnicas, de idioma y publicitarias de Google AdSense. </span>
            Si solo aceptas las necesarias, los anuncios se mostrarán sin personalizar.{" "}
            <Link to="/cookies" data-testid="cookie-policy-link" className="text-cyan-700 underline underline-offset-2 hover:text-cyan-800">
              Más información
            </Link>
          </p>
        </div>
      </div>
      <div className="mt-3 sm:mt-4 flex gap-2">
        <Button data-testid="cookie-accept-all-btn" onClick={() => choose("all")}
          className="flex-1 h-10 rounded-full bg-cyan-500 hover:bg-cyan-600">
          Aceptar todas
        </Button>
        <Button data-testid="cookie-essential-only-btn" onClick={() => choose("essential")} variant="outline"
          className="flex-1 h-10 rounded-full border-slate-300">
          Solo necesarias
        </Button>
      </div>
    </div>
  );
};
